<template>
  <q-btn
    flat
    no-caps
    :class="isActive ? '' : 'text-grey-5'"
    class="site-category-chip"
    @click="$emit('toggle')"
  >
    <SiteIcon
      :social-site="platform"
      :color="isActive ? '' : 'grey-5'"
      size="sm"
    />
  </q-btn>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { SocialSite } from '@/type';
import SiteIcon from '@/social/site/SiteIcon.vue';

export default defineComponent({
  emits: ['toggle'],
  name: 'PlatformToggleButton',
  components: { SiteIcon },
  props: {
    platform: {
      type: Object as () => SocialSite,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
  },
});
</script>
